// extracted by mini-css-extract-plugin
export default {"orders":"style_orders__LEqVD","mobile_flex":"style_mobile_flex__rRhUP","mobile_order_btn":"style_mobile_order_btn__LcoPi","mobile_create_btn":"style_mobile_create_btn__m325y"};